import React, { useState, useEffect } from 'react';
import CategoryTable from '../componenents/Tables/CategoryTable';
import { gql, useQuery } from '@apollo/client';
import { message, Spin } from 'antd';
import SubCategoryTable from '../componenents/Tables/SubCategoryTable';



const SubCategoriesPage = () => {
 

  return (
    <div>
      <h1>List of Sub-Categories</h1>
      <SubCategoryTable  />
    </div>
  );
};

export default SubCategoriesPage;
